import { createSlice } from "@reduxjs/toolkit";

const partOffers = createSlice({
  name: "partOffers",
  initialState: {
    partOffer: {
      count: 0,
      rows: [],
    },
    singlePartOffer: null,
    isLoaded: false,
    isSingleLoaded: false,
  },
  reducers: {
    getPartOffer(state, action) {
      return state;
    },
    setPartOffer(state, action) {
      state.partOffer = action.payload;
      state.isLoaded = true;
    }
    ,
    getSinglePartOffer(state) {
      return { ...state, isSingleLoaded: false };
    },
    setSinglePartOffer(state, action) {
      state.singlePartOffer = action.payload;
      state.isSingleLoaded = true;
    },
  },
});

export const {
  getPartOffer,
  setPartOffer,
  getSinglePartOffer,
  setSinglePartOffer
} = partOffers.actions;

export default partOffers.reducer;
